export type VideoGenerationReceipt={
  version:1;videoUrl:string;receivedAt:string;requestedModel?:string;actualModel?:string;
  provider?:'sedeo'|'kling';actualDurationSeconds?:number;
};
const record=(v:unknown):v is Record<string,unknown>=>!!v&&typeof v==='object'&&!Array.isArray(v);
const model=(v:unknown):v is string=>typeof v==='string'&&/^[a-zA-Z0-9._:/-]{1,128}$/.test(v);
/** Bad optional metadata must not turn an already generated video into a failed job. */
export function readVideoGenerationReceipt(value:unknown,expectedVideoUrl?:string):VideoGenerationReceipt|undefined{
  if(!record(value)||value.version!==1||typeof value.videoUrl!=='string'||typeof value.receivedAt!=='string')return;
  if(expectedVideoUrl!==undefined&&value.videoUrl!==expectedVideoUrl)return;
  try{
    const url=new URL(value.videoUrl);
    if(url.protocol!=='https:'||url.username||url.password||new Date(value.receivedAt).toISOString()!==value.receivedAt)return;
  }catch{return;}
  const receipt:VideoGenerationReceipt={version:1,videoUrl:value.videoUrl,receivedAt:value.receivedAt};
  if(model(value.requestedModel))receipt.requestedModel=value.requestedModel;
  if(model(value.actualModel))receipt.actualModel=value.actualModel;
  if(value.provider==='sedeo'||value.provider==='kling')receipt.provider=value.provider;
  if(typeof value.actualDurationSeconds==='number'&&Number.isFinite(value.actualDurationSeconds)&&value.actualDurationSeconds>0)
    receipt.actualDurationSeconds=value.actualDurationSeconds;
  return receipt;
}
export function createVideoGenerationReceipt(result:unknown,requestedModel:unknown,receivedAt:string):VideoGenerationReceipt|undefined{
  if(!record(result))return;
  return readVideoGenerationReceipt({version:1,videoUrl:result.videoUrl,receivedAt,requestedModel,
    actualModel:result.actualModel,provider:result.provider,actualDurationSeconds:result.actualDurationSec});
}
